// CORTE 3-A — i18n del ESCÁNER anónimo. Idioma resuelto POR REQUEST en el
// backend (Accept-Language + CF-IPCountry), independiente del dueño y del
// vehículo. Tercer eje: protection_type (vehicle/kid/pet/object/other).
// REGLA DURA: si falta el copy de un tipo NO se cae a "vehicle" — se marca
// [missing:...] y el test T2 (eje 3) rompe el build.
import DICT from "./publicScanner.json";

const SUPPORTED = ["es", "en", "pt", "fr"];
const TYPES = ["vehicle", "kid", "pet", "object", "other"];

let _lang = "en";
let _type = "vehicle";

export function setScannerLocale(lang, protectionType) {
  _lang = SUPPORTED.includes(lang) ? lang : "en";
  _type = TYPES.includes(protectionType) ? protectionType : "vehicle";
}

export function browserLangFallback() {
  try {
    const nav = (navigator.language || "en").slice(0, 2).toLowerCase();
    return SUPPORTED.includes(nav) ? nav : "en";
  } catch (_) { return "en"; }
}

function _cap(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }

export function T(key, vars) {
  const d = DICT[_lang] || DICT.en;
  let node = d[key];
  if (node === undefined) return `[missing:${_lang}.${key}]`;
  if (typeof node === "object") {
    node = node[_type];
    if (node === undefined) return `[missing:${_lang}.${key}.${_type}]`;
  }
  let text = String(node);
  const ownerNode = d.owner || {};
  const owner = ownerNode[_type] || `[missing:${_lang}.owner.${_type}]`;
  text = text.replaceAll("{owner}", owner).replaceAll("{Owner}", _cap(owner));
  // 3-B: contracciones gramaticales tras sustituir {owner} (es: a el→al, de el→del;
  // fr: de le→du, à le→au; pt: de o→do, a o→ao). Determinísticas en cada idioma.
  if (_lang === "es") text = text.replaceAll(" a el ", " al ").replaceAll(" de el ", " del ");
  else if (_lang === "fr") text = text.replaceAll(" de le ", " du ").replaceAll(" à le ", " au ");
  else if (_lang === "pt") text = text.replaceAll(" de o ", " do ").replaceAll(" a o ", " ao ");
  if (vars) {
    Object.entries(vars).forEach(([k, v]) => { text = text.replaceAll(`{${k}}`, v); });
  }
  return text;
}

export function scannerType() { return _type; }

export function ownerShort() {
  const d = DICT[_lang] || DICT.en;
  return (d.owner_short || {})[_type] || `[missing:${_lang}.owner_short.${_type}]`;
}
